import { render, staticRenderFns } from "./notificationList.vue?vue&type=template&id=0c0e09e0&scoped=true&"
import script from "./notificationList.vue?vue&type=script&lang=js&"
export * from "./notificationList.vue?vue&type=script&lang=js&"
import style0 from "./notificationList.vue?vue&type=style&index=0&id=0c0e09e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e09e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardText,VIcon,VList,VListItem})
